import { useEffect, useState } from 'react';

export function useKeyboardShortcuts() {
  const [isShortcutsModalOpen, setIsShortcutsModalOpen] = useState(false);

  useEffect(() => {
    const handleKeyPress = (event: KeyboardEvent) => {
      // Ignore if typing in input/textarea
      const target = event.target as HTMLElement;
      if (
        target.tagName === 'INPUT' ||
        target.tagName === 'TEXTAREA' ||
        target.isContentEditable
      ) {
        return;
      }

      // Show shortcuts modal with '?'
      if (event.key === '?' && !event.metaKey && !event.ctrlKey) {
        event.preventDefault();
        setIsShortcutsModalOpen(true);
        return;
      }

      // Close modal with Escape
      if (event.key === 'Escape') {
        setIsShortcutsModalOpen(false);
      }

      // Navigation shortcuts with 'g' prefix
      // This would require a more complex implementation with key sequences
      // For now, keeping it simple with just the modal toggle
    };

    window.addEventListener('keydown', handleKeyPress);

    return () => {
      window.removeEventListener('keydown', handleKeyPress);
    };
  }, []);

  return {
    isShortcutsModalOpen,
    setIsShortcutsModalOpen
  };
}
